module.exports = __webpack_public_path__ + "img/daren_10.cf2c4ade.png";